export default () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 3.5C17.3284 3.5 18 4.17157 18 5V13C18 13.8284 17.3284 14.5 16.5 14.5H5V3.5H16.5Z" stroke="#527195" />
    <rect x="5.5" y="4" width="6" height="5" fill="#527195" />
    <rect x="11.5" y="9" width="6" height="5" fill="#527195" />
    <path d="M4.5 3V19" stroke="#527195" strokeWidth="2" strokeLinecap="round" />
  </svg>
)
